import { spacingTokens } from '../theme/spacing/values.js';

var BASE_UNIT = 4;
var DEFAULT_PIXEL_SIZE = 16;
/**
 * takes a pixel value (number) and returns a string in rem
 * @example unit(16) => '1rem'
 */
function pxToRem(px) {
  return px / DEFAULT_PIXEL_SIZE + "rem";
}
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` instead. Example: `themeGet('spacing.small')`
 */
function spacing(value) {
  if (typeof value === 'number') {
    return pxToRem(value * BASE_UNIT);
  }
  var spacingValue = spacingTokens[value];
  return spacingValue || value;
}
/**
 * @deprecated Use pxToRem instead
 */
var unit = spacing;
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var padding = function padding() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return "padding: " + args.map(function (multiple) {
    return unit(multiple);
  }).join(' ') + ";";
};
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var paddingTop = function paddingTop(multiple) {
  return "padding-top: " + unit(multiple);
};
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var paddingRight = function paddingRight(multiple) {
  return "padding-right: " + unit(multiple);
};
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var paddingBottom = function paddingBottom(multiple) {
  return "padding-bottom: " + unit(multiple);
};
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var paddingLeft = function paddingLeft(multiple) {
  return "padding-left: " + unit(multiple);
};
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var margin = function margin() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return "margin: " + args.map(function (multiple) {
    return unit(multiple);
  }).join(' ') + ";";
};
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var marginTop = function marginTop(multiple) {
  return "margin-top: " + unit(multiple);
};
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var marginRight = function marginRight(multiple) {
  return "margin-right: " + unit(multiple);
};
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var marginBottom = function marginBottom(multiple) {
  return "margin-bottom: " + unit(multiple);
};
/**
 * @deprecated Use `themeGet('spacing.{spacingVariable}')` or pxToRem(number) instead. Example: `themeGet('spacing.small')` or pxToRem(15)
 */
var marginLeft = function marginLeft(multiple) {
  return "margin-left: " + unit(multiple);
};

export { DEFAULT_PIXEL_SIZE, margin, marginBottom, marginLeft, marginRight, marginTop, padding, paddingBottom, paddingLeft, paddingRight, paddingTop, pxToRem, spacing, unit };
